import IndividualComment from "../atoms/IndividualComment";
import IndividualCommentFooter from "../atoms/IndividualCommentFooter";
import { Card } from "@material-ui/core";
import styles from "../../../styles/styles";

const CommentBox = (props) => {
  const { id, comment, createdAt, commentCreatedBy } = props;
  return (
    <div style={{ width: "100%" }}>
      <Card variant="outlined" style={styles.card}>
        <IndividualComment comment={comment} commentID={id} />
      </Card>
      <IndividualCommentFooter
        createdAt={createdAt}
        commentCreatedBy={commentCreatedBy}
      />
    </div>
  );
};

export default CommentBox;
